import script from "./PathogenicMicroorganismCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PathogenicMicroorganismCard.vue?vue&type=script&setup=true&lang=js"

import "./PathogenicMicroorganismCard.vue?vue&type=style&index=0&id=9fe3f7b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fe3f7b2"]])

export default __exports__